import { CA } from '../../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { UIEndGameShareImage } from '../../ui_share_image/UIEndGameShareImage.ts';
import { UIEndGameTitleImage } from '../../ui_share_image/UIEndGameTitleImage.ts';
import { showShareImageDialog } from '../../ui_popup/share_image_dialog/showShareImageDialog.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { UIReplayShareController } from '../../ui_replay/UIReplayShareController.ts';
export class UIGameEndShareButtonController {
    onClickShare() {
        this.openShareImagePopup(false);
        UIGameEndShareButtonController.sendShareButtonClickAnalytic();
    }
    openShareImagePopup(delay) {
        if (delay) {
            setTimeout(()=>this.openShareImagePopup(false), 3000);
            return;
        }
        showShareImageDialog({
            images: this.getImages(),
            onReplayShare: this.getReplayShareAction()
        });
    }
    getImages() {
        if (this.images != undefined) return this.images;
        const shareImage = new UIEndGameShareImage(this.uiGameManager, this.gameEndController.endGameState);
        this.shareImage = shareImage;
        const titleImage = this.titleImage;
        this.images = [];
        if (titleImage != undefined) {
            this.images.push({
                id: 'player-title',
                kind: 'playerTitle',
                title: {
                    key: 'strings:game.endGame.shareImagePopup.achievement'
                },
                getImageFile: ()=>titleImage.getImageFile(),
                achievementEnum: titleImage.title
            });
        }
        this.images.push({
            id: 'game-results',
            kind: 'gameResult',
            title: {
                key: 'strings:game.endGame.shareImagePopup.results'
            },
            getImageFile: ()=>shareImage.getImageFile()
        });
        return this.images;
    }
    shouldShowShareGameResultsPopupAutomaticallyOnGameEnd() {
        if (this.uiGameManager.gameController.isReplay) return false;
        if (UIUtilsEjsVariables.isUserOnDiscord) return true;
        return false;
    }
    static sendShareButtonClickAnalytic() {
        const endGameShareEvent = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton
        };
        void CA.sendAnalyticEventOnce(endGameShareEvent);
    }
    getReplayShareAction() {
        if (!UIUtilsEjsVariables.isUserOnMobile) return undefined;
        if (!this.gameEndController.isReplayAvailable) return undefined;
        return async ()=>{
            var _this_uiGameManager_gameStore_getState_gameReplay_replayControls;
            const replayControlsOnShare = (_this_uiGameManager_gameStore_getState_gameReplay_replayControls = this.uiGameManager.gameStore.getState().gameReplay.replayControls) === null || _this_uiGameManager_gameStore_getState_gameReplay_replayControls === void 0 ? void 0 : _this_uiGameManager_gameStore_getState_gameReplay_replayControls.onShare;
            if (replayControlsOnShare) return replayControlsOnShare();
            await UIReplayShareController.shareOrCopyLink(this.uiGameManager.gameController);
        };
    }
    constructor(uiGameManager, gameEndController){
        var _this_gameEndController_endGamePlayerState;
        this.uiGameManager = uiGameManager;
        this.gameEndController = gameEndController;
        if (((_this_gameEndController_endGamePlayerState = this.gameEndController.endGamePlayerState) === null || _this_gameEndController_endGamePlayerState === void 0 ? void 0 : _this_gameEndController_endGamePlayerState.title) != null) {
            this.titleImage = new UIEndGameTitleImage(this.uiGameManager, this.gameEndController.endGamePlayerState.title, this.gameEndController.endGameState);
        }
        if (this.shouldShowShareGameResultsPopupAutomaticallyOnGameEnd()) this.openShareImagePopup(true);
    }
}
